import { BASE_URL } from '.';

const tokenData: any = localStorage.getItem('token');
const token = tokenData;

export const api_updateProfile = async (payload: any, token: string, authId: string) => {
	const uri = `${BASE_URL}/users/${authId}`;

	const response = await fetch(uri, {
		method: 'PUT',
		headers: {
			'Content-Type': 'multipart/form-data',
			authorization: `Bearer ${token}`,
		},
		body: payload,
	}).then((res) => res.json());

	return response;
};

export const api_getUserById = async (token: string, authId: string) => {
	const uri = `${BASE_URL}/users/getById/${authId}`;
	const response = await fetch(uri, {
		method: 'GET',
		headers: {
			'Content-Type': 'application/json',
			authorization: `Bearer ${token}`,
		},
	}).then((res) => res.json());
	if (!response.isSuccess) {
		throw new Error(response.error || 'something went wrong!');
	}
	return response;
};

export const api_getAllUsers = async (token: string, pageNo: number, pageSize: number) => {
	const uri = `${BASE_URL}/users?page=${pageNo}&offset=${pageSize}`;

	try {
		const response = await fetch(uri, {
			method: 'GET',
			headers: {
				'Content-Type': 'application/json',
				authorization: `Bearer ${token}`,
			},
		});
		if (!response.ok) {
			throw new Error(`HTTP error! Status: ${response.status}`);
		}

		const data = await response.json();
		return { isSuccess: true, data };
	} catch (error) {
		console.error('Fetch error:', error);
		return { isSuccess: false, message: error };
	}
};

export const api_getUsersByFilter = async (searchString: string) => {
	const uri = `${BASE_URL}/users/filter?searchString=${searchString}`;

	try {
		const response = await fetch(uri, {
			method: 'GET',
			headers: {
				'Content-Type': 'application/json',
				authorization: `Bearer ${token}`,
			},
		});
		if (!response.ok) {
			throw new Error(`HTTP error! Status: ${response.status}`);
		}

		const data = await response.json();
		return { isSuccess: true, data };
	} catch (error) {
		console.error('Fetch error:', error);
		return { isSuccess: false, message: error };
	}
};

export const api_getAllUsersByRole = async (role: string) => {
	const uri = `${BASE_URL}/users/getUsersByRole?role=${role}`;

	try {
		const response = await fetch(uri, {
			method: 'GET',
			headers: {
				'Content-Type': 'application/json',
				authorization: `Bearer ${token}`,
			},
		});
		if (!response.ok) {
			throw new Error(`HTTP error! Status: ${response.status}`);
		}

		const data = await response.json();
		return { isSuccess: true, data };
	} catch (error) {
		console.error('Fetch error:', error);
		return { isSuccess: false, message: error };
	}
};

export const api_getTotalUsers = async (role: string) => {
	const uri = `${BASE_URL}/users/getTotal?role=${role}`;

	try {
		const response = await fetch(uri, {
			method: 'GET',
			headers: {
				'Content-Type': 'application/json',
				authorization: `Bearer ${token}`,
			},
		});
		if (!response.ok) {
			throw new Error(`HTTP error! Status: ${response.status}`);
		}

		const data = await response.json();
		return { isSuccess: true, data };
	} catch (error) {
		console.error('Fetch error:', error);
		return { isSuccess: false, message: error };
	}
};

export const api_userCreate = async (payload: any) => {
	try {
		const uri = `${BASE_URL}/users/register`;
		const response = await fetch(uri, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify(payload),
		});

		if (!response.ok) {
			return {
				isSuccess: false,
				error: 'Failed to create user',
			};
		}

		const data = await response.json();
		return {
			isSuccess: true,
			data,
			message: 'User created successfully',
		};
	} catch (error) {
		return {
			isSuccess: false,
			error: error || 'Something went wrong!',
		};
	}
};

export const api_userProfileUpdate = async (userId: string, token: string, formData: FormData) => {
	try {
		const uri = `${BASE_URL}/users/${userId}`;
		const response = await fetch(uri, {
			method: 'PUT',
			headers: {
				authorization: `Bearer ${token}`,
			},
			body: formData,
		});

		const data = await response.json();

		if (!response.ok || !data.isSuccess) {
			throw new Error(data.error || 'Something went wrong!');
		}

		return data;
	} catch (error) {
		return {
			isSuccess: false,
			error: error || 'Something went wrong!',
		};
	}
};
